module.exports = __webpack_public_path__ + "static/mobile-app-img-3-bd3bc3d96f19b5d40cbda44afc5f9429.png";